import { ScreenManager } from './components/Player/ScreenManager'
import { SWRConfig } from 'swr'
import { fetcher } from './api'
import { PlaylistPlayer } from './components/Player/PlaylistPlayer'
import { ScreenContainer } from './components/Player/ScreenContainer'
import { SchedulePlayer } from './components/Player/SchedulePlayer'
import { ChannelPlayer } from './components/Player/ChannelPlayer'
import { lazy, Suspense } from 'react'
const CanvasLayoutPlayer = lazy(() =>
  import('./components/Player/CanvasLayoutPlayer').then((m) => ({ default: m.CanvasLayoutPlayer }))
)
import { LivePreviewHost } from './components/Player/LivePreviewHost'
import { keepScreenAwake, reloadAppDaily } from './utils'
import './App.css'
import { getLogger } from './logger'
import { getAutoplayCheckPromise } from './autoplay'
import { OverlayInfoText } from './components/Player/OverlayInfo'
import { initAnalytics } from './analytics'
import { setClockOffset } from 'common/clock'

const log = getLogger('app')

initAnalytics()

const url = new URL(window.location.href)
const { searchParams } = url
const previewPlaylistId = searchParams.get('playlistId')
const previewChannelId = searchParams.get('channelId')
const previewCanvasLayoutId = searchParams.get('canvasLayoutId')
const previewScheduleId = searchParams.get('scheduleId')

const previewScreen = {
  orientation: searchParams.get('orientation') || '0',
}

const isLivePreview = searchParams.get('previewMode') === 'live'
const isPreview = !!previewPlaylistId || !!previewChannelId || !!previewCanvasLayoutId || !!previewScheduleId

// Lets a preview be pinned to another moment, e.g. ?at=2026-08-31T09:00, so a schedule can be
// checked without waiting for that day. Never read outside preview, so screens are unaffected.
const previewAt = isPreview ? Date.parse(searchParams.get('at') || '') : Number.NaN
if (!Number.isNaN(previewAt)) {
  setClockOffset(previewAt - Date.now())
}

const previewLabel = Number.isNaN(previewAt)
  ? 'Screen preview'
  : `Screen preview · ${new Date(previewAt).toLocaleString()}`

const debugMode = searchParams.has('debug') && url.searchParams.get('debug') !== '0'

if (debugMode) {
  log('Debug mode is enabled!')
}
export const isDebugEnabled = () => debugMode

reloadAppDaily()

if (!isPreview && !isLivePreview) {
  keepScreenAwake()
}

getAutoplayCheckPromise().catch((err) => {
  log('Error in autoplay check', err)
})

function App() {
  return (
    <SWRConfig
      value={{
        fetcher,
      }}
    >
      {isLivePreview ? (
        <LivePreviewHost />
      ) : isPreview ? (
        <ScreenContainer screen={previewScreen}>
          <OverlayInfoText text={previewLabel} moveIntervalInSeconds={5} />
          {!!previewScheduleId ? (
            <SchedulePlayer scheduleId={previewScheduleId} isPreview={isPreview} />
          ) : !!previewCanvasLayoutId ? (
            <Suspense fallback={null}>
              <CanvasLayoutPlayer layoutId={previewCanvasLayoutId!} isPreview={isPreview} />
            </Suspense>
          ) : !!previewChannelId ? (
            <ChannelPlayer channelId={previewChannelId!} isPreview={isPreview} />
          ) : (
            <PlaylistPlayer playlistId={previewPlaylistId!} isPreview={isPreview} />
          )}
        </ScreenContainer>
      ) : (
        <ScreenManager />
      )}
    </SWRConfig>
  )
}

export default App
